module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_cell_transport_5-93842ef1c4f2f99389bf3dc362395e3a.jpg";